export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.978.656l2.037.937a.51.51 0 01.25.671l-.635 1.387a.14.14 0 01-.184.065L8.738 2.47a.135.135 0 01-.07-.179L9.306.906a.51.51 0 01.671-.25zM8.193 3.46a.135.135 0 01.09-.005l2.708 1.24a.135.135 0 01.065.18l-2.849 6.169a.445.445 0 01-.157.19l-1.625 1.12a.628.628 0 01-.406.104H2.08a.542.542 0 110-1.084h3.336l-.184-1.451a.471.471 0 01.038-.244L8.126 3.52a.135.135 0 01.067-.06z\" fill=\"#717684\"/>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};